// Monochrome brand marks served from Simple Icons CDN (CC0).
// Single source — no extra dependency, identical aesthetic across the grid.
const SLUGS = {
  react: "react",
  fastapi: "fastapi",
  mongodb: "mongodb",
  gsap: "greensock",
  python: "python",
  openai: "openai",
  cloudflare: "cloudflare",
  stripe: "stripe",
  github: "github",
  figma: "figma",
  vercel: "vercel",
};

const COLOR = "e2e8f0"; // soft white — sits well on near-black surfaces

export default function TechLogo({ id, name, size = 28, className = "" }) {
  const slug = SLUGS[id];
  if (!slug) {
    // Letter fallback keeps the layout intact even if a CDN entry is missing.
    return (
      <span
        aria-hidden
        className={`inline-flex items-center justify-center rounded-md bg-white/[0.04] text-white/70 ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.5 }}
      >
        {name?.[0] ?? "?"}
      </span>
    );
  }
  return (
    <img
      src={`https://cdn.simpleicons.org/${slug}/${COLOR}`}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={`block opacity-90 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
